<template>
  <div class="wrap">
    <v-header :inputName='Name'></v-header>
    <div class="mbanner">
      <img src="../images/mban.jpg">
      <div class="text flex-center">
        <div class="xian"></div>
        <span>{{typeName}}</span>
        <div class="xian"></div>
      </div>
    </div>
    <div class="m_centre">
      <div class="mzixunWrap">
        <div class="mzixunLeft">
          <ul class="mzixunTab">
            <li v-for="item in typeList" :class="{active:index == item.index}" @click="changeindex(item.index)">
              {{item.name}}</li>
          </ul>
          <!--高考资讯-->
          <div class="mzixunPage" style="display: block;">
            <ul class="mzixunList" style="min-height: 570px;">
              <li v-for="item in list">
                <router-link target="_blank" :to="{path:'/newsDetail',query:{id:item.newsId,Name:Name,typeid:index,type:type}}" class="img-box">
                  <img :src="($resourcesUrl+`${item.newsImg}`)"></router-link>
                <div class="txt-box">
                  <router-link target="_blank" :to="{path:'/newsDetail',query:{id:item.newsId,Name:Name,typeid:index,type:type}}" class="t1">{{item.newsTitle}}</router-link>
                  <time>发表于：{{item.newsReleaseTime}}</time>
                </div>
              </li>
            </ul>
            <div class="fanye" v-if="pages>1">
              <span @click="chagepage(1)" class="page">首页</span>
              <span v-if="pageNum > 1" @click="chagepage(pageNum-1)" class="pagebox">
                < </span>
                  <span @click="chagepage(item)" class="pagebox" :class="{active:item == pageNum}"
                    v-for="item in pages"> {{item}} </span>
                  <span v-if="pageNum <pages " @click="chagepage(pageNum+1)" class="pagebox"> > </span>
                  <span @click="chagepage(pages)" class="page">末页</span>
                  <p>共{{total}}条记录</p>
            </div>
          </div>
        </div>
        <div class="mzixunRight">
          <div class="mzixunWenda">
            <div class="mzixunTitle flex-between">
              <h4>{{typeName}}</h4>
            </div>
            <ul class="mwendaList">
              <li v-for="(item,i) in listone">
                <span>{{i+1}}</span>
                <router-link :to="{path:'/newsDetail',query:{id:item.newsId,Name:Name,typeid:index,type:type}}">{{item.newsTitle}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边固定 -->
    <zuoxuanfu1></zuoxuanfu1>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import item7 from '../../components/item7.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1
    },
    data() {
      return {
        // 导航选中
        Name: 5,
        typeName: '',
        typeList: [],
        list: [],
        listone:[],
        index: 0,
        pageSize: 8,
        pageNum: 1,
        pages: 0,
        total: 0,
        type:'gkzx',
        userInfo:this.$utils.getlocalStorage('userInfo')

      }
    },
    watch: {
      '$route.query.type': function(vl) {
        this.gettypedata()
      }
    },
    created() {
      console.log('newList')
      this.gettypedata()

    },
    methods: {
      gettypedata() {
        let NEWSPARENT = this.$utils.getlocalStorage('NEWSPARENT')
        let NEWSAllOBJ = this.$utils.getlocalStorage('NEWSAllOBJ')
        this.typeName = NEWSPARENT[this.$route.query.type]
        this.typeList = NEWSAllOBJ[this.$route.query.type]
        this.Name = parseInt(this.$route.query.Name)
        this.type  =  this.$route.query.type
        if(this.$route.query.typeid!=null){
          this.index = this.$route.query.typeid
        } else {
          this.index = this.typeList[0].index
        }
        this.getData()
        this.getDataone()
      },
      changeindex(index) {
        this.index = index
        this.pageNum = 1
        this.list = []
        this.pages = 0
        this.total = 0
        this.getData()
        this.getDataone()
      },
      chagepage(page) {
        if (page != this.pageNum) {
          this.pageNum = page
          this.getData()
        }
      },
      getData() {
        let _this = this;
        let newsArea = 990000
        if(this.userInfo!=null){
          newsArea = this.userInfo.userProvinces
        }
        this.$req.queryAllByLimit("newsTable", {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          queryObj: {
            newsTypeId: this.index,
            newsStatus:1,
            newsArea:newsArea
          }
        }).then(function(response) {
          _this.list = response.data
          _this.total = response.total
          _this.pages = response.pages
        })
      },
      getDataone() {
        let _this = this;
        let newsArea = 990000
        if(this.userInfo!=null){
          newsArea = this.userInfo.userProvinces
        }
        this.$req.queryAllByLimit("newsTable", {
          pageSize: 10,
          pageNum: 1,
          queryObj: {
            newsTypeId: this.index,
            newsStatus:1,
            newsArea:newsArea
          }
        }).then(function(response) {
          _this.listone = response.data
        })
      }

    }


  }
</script>

<style scoped>
  /* 右边固定 */
  .zuotab {
    height: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%);
  }

  .zuotab figure {
    cursor: pointer;
    margin: 8px 0;
    width: 64px;
    height: 62px;
    border: 1px solid #FF0000;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .zuotab figure img {
    width: 20px;
    height: 20px;
  }

  .zuotab figure figcaption {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/news/newsList.vue